(() => {
  // app/scripts/product-table.js
  !customElements.get("product-table") && customElements.define(
    "product-table",
    class ProductTable extends HTMLElement {
      constructor() {
        super();
        this.variantSortings = this.querySelectorAll(".jsVariantSorting");
      }
      connectedCallback() {
        this.setupEventListeners();
      }
      setupEventListeners() {
        if (this.variantSortings.length > 0) {
          this.variantSortings.forEach((el) => {
            el.addEventListener("click", this.handleVariantSorting.bind(el));
          });
        }
      }
      handleVariantSorting(el) {
        const target = el.target;
        const dataSort = target.getAttribute("data-sort");
        const sortingWrapper = this.closest(".product-table").querySelector(".jsSortingWrapper");
        const variantItems = Array.from(sortingWrapper.querySelectorAll(".variant-item"));
        const isDescending = target.classList.contains("sorted");
        const numericSort = (attr, desc = false) => (a, b) => {
          const valA = parseFloat(a.getAttribute(attr));
          const valB = parseFloat(b.getAttribute(attr));
          return desc ? valB - valA : valA - valB;
        };
        const splitSort = (attr, desc = false) => (a, b) => {
          const [a1, a2] = a.getAttribute(attr).split("X").map(Number);
          const [b1, b2] = b.getAttribute(attr).split("X").map(Number);
          if (a1 !== b1)
            return desc ? b1 - a1 : a1 - b1;
          return desc ? b2 - a2 : a2 - b2;
        };
        const sorters = {
          price: numericSort("data-price", isDescending),
          stock: numericSort("data-stock", !isDescending),
          hub_bore: numericSort("data-bore", isDescending),
          offset: numericSort("data-offset", isDescending),
          bolt: splitSort("data-bolt", isDescending),
          size: splitSort("data-size", isDescending)
        };
        if (sorters[dataSort]) {
          variantItems.sort(sorters[dataSort]);
        }
        sortingWrapper.innerHTML = "";
        variantItems.forEach((item) => sortingWrapper.appendChild(item));
        target.classList.toggle("sorted");
      }
    }
  );
})();
